module.exports = __webpack_public_path__ + "img/WarumDieSocke.0a347aac.svg";